"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=core_hal_interface.js.map